import styled from 'styled-components';
import { grey900 } from '../theme/theme/colors';

const PlainLink = styled.a`
  color: ${props =>
    props.isSunseekerPromotion
      ? grey900
      : props.theme.colors.common[props.isLight ? 'linkLight' : 'link']};

  &:hover,
  &:active {
    color: ${props =>
      props.isSunseekerPromotion
        ? grey900
        : props.theme.colors.common[
            props.isLight ? 'linkLightActive' : 'linkActive'
          ]};
    text-decoration: underline;
  }
`;

export default PlainLink;
